import { gql } from '@apollo/client';
import fdaPracticeAreaFragment from './fdaPracticeAreaFragment';

const GET_FDA_CONTRACT_BASELINE_REPORT = gql`
  query GetFdaContractBaselineReport($ohts: [Int!], $orgId: Int) {
    fdaContractBaselineReport(ohts: $ohts, orgId: $orgId) {
      ...FdaPracticeAreaFragment
    }
  }

  ${fdaPracticeAreaFragment}
`;

export default GET_FDA_CONTRACT_BASELINE_REPORT;
